
import StorageManager from "../services/StorageManager.service";
import jwtDecode from "jwt-decode";
import SharedString from "../utils/SharedString";

export function getLoginFormHeader() {
    let headers;
    const token = StorageManager.getJWTToken();

    if (token) {
        headers = {
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            "Authorization":"Bearer "+ token,
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE"
        };
    } else {
        headers = {
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
        };
    }
    return headers;
}

export function getHeaderNoAuth(){
    return  {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    }
}
export function getJWTHeaders() {
    let headers;
    const token = StorageManager.getJWTToken();

    if (token) {
        headers = {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization":"Bearer "+ token,
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE"
        };
    } else {
        headers = {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
        };
    }
    return headers;
}

export function getJWTHeadersMulti() {
    const token = StorageManager.getJWTToken();
    let headers;
    if (token) {
        headers = {
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Authorization":"Bearer "+ token,
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
        };
    } else {
        headers = {
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
        };
    }
    return headers;
}

export function isAuthenticated() {
    const token = StorageManager.getJWTToken();

    if(token != null){
        let decodedToken = jwtDecode(token)
        const isExpired = Math.floor(Date.now() / 1000) > decodedToken.exp

        if(isExpired){
            StorageManager.clearUserInfo();
        }

        return token && !isExpired
    }

    return !!token
}

export function isAdminAuthenticated(){
    let isAuthValid = isAuthenticated();

    if(isAuthValid){
        let decodedToken = jwtDecode(StorageManager.getJWTToken())
        let isAdmin = decodedToken.ROLE[0].authority === SharedString.ROLE_ADMIN
        
        return isAuthValid && isAdmin
    }

    return false;
}

export function deleteJWT() {
    StorageManager.clearJWTToken();
}


export function isLogged() {
    return StorageManager.getLoginStatus();
}

export async function checkExpJwt() {
    const token = StorageManager.getJWTToken();
    try {
        const decoded = await parseJwt(token);
        let isExpired = await decoded.exp < Date.now() / 1000;
        if (isExpired) {
            deleteJWT();
            window.location.href = '/login';
        }
        return isExpired;
    } catch (err) {
        deleteJWT();
        window.location.href = '/login';
        console.error("error check jwt");
    }
    return false;
}


export function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
}

export function handleLoginResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                StorageManager.storeLoginStatus(false);
                console.log("logout if 401 Unauthorized or 403 Forbidden response returned from api")
                throw new Error("Status: " + 401);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        } else {
            //SAVEJWT
        }

        return data;
    });

}


export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                StorageManager.storeLoginStatus(false);
                console.log("logout if 401 Unauthorized or 403 Forbidden response returned from api")

                throw new Error("Status: " + 401);

            } else if ([500, 503].indexOf(response.status) !== -1) {
                // server error

                console.log("server error " + response.status)

                throw new Error("Status: " + 500);

            } else if ([404].indexOf(response.status) !== -1) {
                // server error

                console.log("404 not found " + response.status)

                throw new Error("Status: " + 404);

            } else {
                console.log("error " + response.status)
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });

}